<template>
  <figure class="w-full h-auto aspect-[148/120] relative overflow-hidden rounded-[0.625rem] bg-white">
    <img
      v-show="Boolean(item?.image) || Array.isArray(item?.images)"
      loading="lazy"
      :src="
        getImage(
          Array.isArray(item?.images) && item?.images?.length > 0 && item?.images?.some((img: IImage) => img?.isTitle)
            ? item?.images?.find((img: IImage) => img?.isTitle)
            : item?.image,
        )
      "
      :alt="item?.fullName"
      class="object-cover aspect-[148/120] w-full h-auto absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
    />
  </figure>
</template>

<script setup lang="ts">
import { IImage } from "@/types"
import { getImage } from "@/services/getImage"

defineProps({
  item: {
    type: Object,
    default: null,
  },
})
</script>
